import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import Swup from 'swup';
import SwupFadeTheme from '@swup/fade-theme';
import SwupSlideTheme from '@swup/slide-theme';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';

const swup = new Swup({
  plugins: [
    // new SwupFadeTheme({
    //   // mainElement: '.swup-fade'
    // }),
    new SwupPreloadPlugin(),
    new SwupHeadPlugin(),
    new SwupScriptsPlugin({
      optin: true
    }),
    new SwupA11yPlugin()
  ]
});
